<template>
    <div style="padding: 5rem;">退出登录成功</div>
</template>

<script>
import cookie from 'js-cookie'
export default {
    name: 'logout',
    data() {
        return {}
    },
    mounted() {

        cookie.remove('sessionid')

        this.$nextTick(() => {

            setTimeout(() => {

                window.location.href = 'login'

            },3000);

        });

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>


// WEBPACK FOOTER //
// src/components/logout.vue